import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
 {
  description: 'Levantamento Estoque Central',
  path: '/merenda/merlevantamentoestoquecentral',
  name: 'merlevantamentoestoquecentral',
  component: () => import('@/views/merenda/merlevantamentoestoquecentral/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.LEVANTAMENTODEESTOQUECENTRALNOVO_MENU_1900200550],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Levantamento Estoque Central',
  path: '/merenda/merlevantamentoestoquecentral/cadastro/:id?',
  parent: 'merlevantamentoestoquecentral',
  name: 'merlevantamentoestoquecentral_create',
  component: () => import('@/views/merenda/merlevantamentoestoquecentral/IncluirEditar.vue'),
  meta: {
   permissions: [eTipoPermissao.LEVANTAMENTODEESTOQUECENTRALNOVO_MENU_1900200550],
  },
  goesToMenu: true,
 },
 {
  description: 'Itens do Levantamento Estoque Central',
  path: '/merenda/merlevantamentoestoquecentral/:id/itens',
  parent: 'merlevantamentoestoquecentral',
  name: 'merlevantamentoestoquecentral_itens',
  component: () => import('@/views/merenda/merlevantamentoestoquecentral/Itens.vue'),
  meta: {
   permissions: [eTipoPermissao.LEVANTAMENTODEESTOQUECENTRALNOVO_MENU_1900200550],
  },
  goesToMenu: false,
 },
]
